const VERTICAL_OFFSET = 10;
const HORIZONTAL_OFFSET = 55;
const GRAPH_OFFSET = HORIZONTAL_OFFSET + 25;

const TOOLTIP_BORDER_RADIUS = 7;
const TOOLTIP_HEIGHT = 72;
const TOOLTIP_WIDTH = 88;
const TOOLTIP_DISTANCE = 32;
const TOOLTIP_TEXT_HEIGHT = TOOLTIP_HEIGHT / 2 - 1;
const TOOLTIP_SUB_TEXT_HEIGHT = TOOLTIP_HEIGHT * 0.75 + 1;

const POINT_RADIUS = 4;
const TEXT_VERTICAL_OFFSET = 35;
const OUTLINE_RADIUS = 10;

const MAX_COLUMN_WIDTH = 30;
const COLUMN_SCALING_FACTOR = 0.9;

const SMOOTHING_FACTOR = 0.2;

export {
    COLUMN_SCALING_FACTOR,
    GRAPH_OFFSET,
    HORIZONTAL_OFFSET,
    MAX_COLUMN_WIDTH,

    OUTLINE_RADIUS,
    POINT_RADIUS,
    SMOOTHING_FACTOR,
    TEXT_VERTICAL_OFFSET,
    TOOLTIP_BORDER_RADIUS,
    TOOLTIP_DISTANCE,

    TOOLTIP_HEIGHT,
    TOOLTIP_SUB_TEXT_HEIGHT,

    TOOLTIP_TEXT_HEIGHT,
    TOOLTIP_WIDTH,

    VERTICAL_OFFSET,
};
